import { IconSVG } from '../types';

export const SentimentSatisfied = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12.5 17.5q1.324 0 2.512-.575a4.7 4.7 0 0 0 1.913-1.675q.274-.424.075-.838-.2-.412-.65-.412a.75.75 0 0 0-.363.088.66.66 0 0 0-.262.262q-.575.775-1.425 1.213a3.9 3.9 0 0 1-1.8.437 3.9 3.9 0 0 1-1.8-.437 4.1 4.1 0 0 1-1.425-1.213.85.85 0 0 0-.287-.262.75.75 0 0 0-.363-.088q-.45 0-.65.4t.075.8q.724 1.124 1.912 1.713a5.65 5.65 0 0 0 2.538.587M16 11q.625 0 1.063-.437.437-.438.437-1.063t-.437-1.062A1.45 1.45 0 0 0 16 8q-.625 0-1.062.438A1.45 1.45 0 0 0 14.5 9.5q0 .624.438 1.063Q15.375 11 16 11m-7 0q.624 0 1.063-.437.437-.438.437-1.063t-.437-1.062A1.45 1.45 0 0 0 9 8q-.625 0-1.062.438A1.45 1.45 0 0 0 7.5 9.5q0 .624.438 1.063Q8.374 11 9 11m3.5 11a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2.5 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12.5 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22.5 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137a9.7 9.7 0 0 1-3.9.788m0-2q3.35 0 5.675-2.325T20.5 12t-2.325-5.675T12.5 4 6.825 6.325 4.5 12t2.325 5.675T12.5 20"
       />
    </svg>
  );
};